import React from 'react';

interface PropsType {
  src?: string;
  childrenImage: React.HTMLProps<React.ReactElement>;
}
const ImageWebP = ({ childrenImage, src }: PropsType) => (
  <picture>
    {src && <source type="image/webp" srcSet={src} />}
    {childrenImage as React.ReactElement}
  </picture>
);

export default ImageWebP;
